(function ($, Global) {
    function RecapModel() {
        // Déclaration class objet
    }

    RecapModel.prototype.subscribe = function (data, callback) {
        var url = 'synthesis/subscribe';

        $.ajaxPost(url, data)
            .done(function (result) {
                Global.ajaxCallback({
                    results: result,
                    success: callback
                })
            });
    }

    Global.RecapModel = RecapModel;
}(jQuery, window));